module.exports = __webpack_public_path__ + "img/ic-gamepals.2723b8d.svg";